import { useMemo } from 'react';
import { ApolloError } from '@apollo/client/errors';
import { ApolloQueryResult } from '@apollo/client';
import {
  CollectorSettingScope,
  CollectorSettingsQuery,
  useCollectorSettingsQuery
} from 'graphql/types';

export const useCollectorSettings = (
  scope: CollectorSettingScope
): {
  data: CollectorSettingsQuery | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (
    variables?: any
  ) => Promise<ApolloQueryResult<CollectorSettingsQuery>>;
} => {
  const { loading, data, error, refetch } = useCollectorSettingsQuery({
    variables: {
      input: {
        filterByScope: scope
      }
    }
  });
  return useMemo(
    () => ({
      loading,
      error,
      data,
      refetch
    }),
    [data, error, loading, refetch]
  );
};
